export const MESSAGES = [{
  id: '5e8883f1b51cc1956a5a1ec0',
  createdAt: 1759847423065,
  title: 'Your order is placed',
  type: 'new_message',
  name: 'Brain Warner',
  message: 'Changed an issue from in this project',
  image: '/static/avatar/001-man.svg'
}, {
  id: '5e8883f7ed1486d665d8be1e',
  createdAt: 1759847423065,
  description: 'You have 32 unread messages',
  title: 'New message received',
  type: 'new_message',
  name: 'Kiara Hamptoon',
  message: 'Nice Work! You really nailed it. Keep it Up Man',
  image: '/static/avatar/002-girl.svg'
}, {
  id: '5e8883fca0e8612044248ecf',
  createdAt: 1759847423065,
  description: 'Dummy text',
  title: 'Your item is shipped',
  type: 'item_shipped',
  name: 'Ruby Walton',
  message: 'Nice Work! You really nailed it. Keep it Up Man',
  image: '/static/avatar/004-woman.svg'
}];
export const ARCHIVES = [{
  id: '5e8883f1b51cc1956a5a1ec0',
  createdAt: 1759847451908,
  title: 'Your order is placed',
  type: '',
  name: 'Brain Warner',
  message: 'Changed an issue from in this project',
  image: '/static/avatar/001-man.svg'
}, {
  id: '5e8883f7ed1486d665d8be1e',
  createdAt: 1759847451908,
  description: 'You have 32 unread messages',
  title: 'New message received',
  type: '',
  name: 'Kiara Hamptoon',
  message: 'Nice Work! You really nailed it. Keep it Up Man',
  image: '/static/avatar/002-girl.svg'
}, {
  id: '5e8883fca0e8612044248ecf',
  createdAt: 1759847451908,
  description: 'Dummy text',
  title: 'Your item is shipped',
  type: 'item_shipped',
  name: 'Ruby Walton',
  message: 'Nice Work! You really nailed it. Keep it Up Man',
  image: '/static/avatar/004-woman.svg'
}];